import type { FaireProductEntity } from "../../entity_types/product";

export const p_9f6wwvssk4: FaireProductEntity = {
  token: "p_9f6wwvssk4",
  type: "product",
  name: "Organic Tallow Lip Balm",
  brandToken: "b_wzhxy9syvt",
  brandName: "Ginger Lily Tallow",
  imageUrl:
    "https://cdn.faire.com/fastly/f8df89ed6ab92654b1b022faeca552600091f49192756b9f25f0f82cdd5c5cbe.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.16,
  description:
    "Organic Tallow Lip Balm – Nourish, Hydrate, and Heal Dry Lips Naturally\n\nPamper your lips with our organic, silky-smooth lip balm designed to hydrate, nourish, and heal. Made with grass-fed tallow, organic mango butter, and organic beeswax, this balm delivers natural moisture and protection to keep lips soft and smooth all day long. Our unique formula is perfect for soothing dry, cracked lips while providing long-lasting hydration.\n\n\n\nGreen Tea – A fresh, lightly herbal scent with a clean, calming feel and subtle earthy brightness. (FO)\nAmber Cheer – A warm, softly sweet amber scent that feels cozy, comforting, and gently uplifting. (FO)\nCreamsicle – A sweet, citrusy treat with vanilla and orange. (EO)\nLemon + Lavender – A soothing, aromatic blend made with essential oils. (EO)\n\n(FO - Made with non-toxic fragrance oils that are formulated without phthalates, parabens or carcinogenic substances.\nEO - Made with pure, 100% natural plant based essential oils.)\n\nPerfect for everyday use, this balm offers a gentle, organic solution to lip care without harmful chemicals.\n\nKey Benefits:\n\nHydrates &amp; Heals: Deeply moisturizes dry, chapped lips.\n\nOrganic Ingredients: Crafted with organic, grass-fed tallow and pure essential oils.\n\nLong-Lasting Protection: Helps protect lips from the elements while keeping them soft and smooth.",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:58.345Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
